export const DISPLAY_DATE_FORMAT = 'dd/MM/yyyy';
export const QUOTE_EXPIRY_DAYS = 45;
export const PROMO_EXPIRY_DATE = '2022-12-20';
